import {View }from "./View"

export const CheckoutPaymentLInk = () => {
    return (
        <View/>
    )
}
